import axios from '@/plugins/axios'
import type { AxiosResponse } from 'axios'

const resource = '/api/v1/field_constraint'

export default {
    getByScope(scope: string): Promise<AxiosResponse<IServerResponse<Array<IFieldConstraint>>>> {
        return axios.get(`${resource}/scope/${scope}`)
    },
}
